module.exports = __webpack_public_path__ + "img/17.18ac951c.png";